export const azishSausages = {
  id: "azishSausages",
  link: "/#/recipes/recipes/azishSausages",
  name: "Azish Sausages",
  cuisine: "Azish",
  summary: "Lightly spiced pork sausages",
  inspiration: "Merguez",
  quantity: "9 5-6 inch sausages",
  time: "3 days",
  notes:
    "Sausages and meat sticks are mentioned often enough in the books that I knew I was going to have to include a sausage recipe. I looked to merguez to match the North African flavors I've used elsewhere in Makabaki dishes. I went with pork shoulder and hog casings as pigs are available in Azir, and it appears sheep are restricted to Shinovar. One last note about the instructions. I am not going to include a full guide on sausage making here. I've included enough that if you're familiar with the process, you should have no problem following this recipe. If you're new to making sausages, though, I recommend the book \"Sausage Making: The Definitive Guide with Recipes\" by Ryan Farr and Jessica Battilana.",
  quotes:
    "Hadn't she found a sausage in the bottom before tossing the pack? (Edgedancer ch 1)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/azish-sausages-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "pork",
          display: "6 ft or more of hog casings"
        },
        {
          item: "hotPeppers",
          display: "2 oz chiles guajillo"
        },
        {
          item: "pork",
          display: "2.4 lbs pork shoulder"
        },
        {
          item: "onion",
          display: "2 heaping tbsps minced onion"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic"
        },
        {
          item: "coriander",
          display: "1/4 tsp ground coriander"
        },
        {
          item: "cumin",
          display: "1/4 tsp ground cumin"
        },
        {
          item: "hotPeppers",
          display: "1/4 tsp chipotle chile powder"
        },
        {
          item: "salt",
          display: "1/2 tbsp salt"
        },
        {
          item: "water",
          display: "1/2 cup ice water"
        },
        {
          item: "onion",
          display:
            "1/3 cup diced green onions (white and light green bits only)"
        }
      ]
    }
  ],
  steps: [
    "Hydrate the hog casings according to package instructions. Soak 2 oz chiles guajillo in warm water for an hour.",
    "Grind the pork shoulder with a 4 or 4.5 mm grinding plate.",
    "Remove the seeds and stems from the soaked peppers. Add them to a bowl along with the minced onion, garlic, coriander, cumin, and chipotle chili powder. Blend to a paste. I used an immersion blender, but a small food processor could work. Press the paste through a mesh strainer to strain out solids to get 1/4 cup paste. Mix the salt into the strained paste.",
    "Fill a very large bowl with ice. Set another large bowl in the ice to keep cold. In that bowl, mix the ground meat, chili paste, ice water, and diced green onions to make the farce. Mix until a bit sticky and a patty will stick to your palm without falling when you hold your hand palm-down.",
    "Take 2 tbsp of the farce and form into a test patty. Cook in a nonstick pan over low heat until cooked through but not browned. Taste the patty and adjust the seasonings if you wish.",
    "Cover the bowl with plastic wrap, making sure the plastic wrap touches the top of the farce to prevent oxidization. Refrigerate overnight.",
    "Stuff the hydrated casings with the farce. Twist into 5-6 inch lengths. Let dry overnight in the refrigerator, hanging or on a wire rack.",
    "Grill at 350 degrees Fahrenheit for 10-13 minutes until 165 degrees Fahrenheit inside as measured with a meat thermometer, turning once."
  ]
}
